import { type PerformanceTrendBucket } from '../performance-api.ts';
import { getBucketKey, type PeriodRange } from './period-range.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';
import { sumTotals } from './totals.ts';

export const buildTrend = (
  completed: SessionsServiceSession[],
  range: PeriodRange,
  timeZone: string
): PerformanceTrendBucket[] => {
  const sessionsByKey = new Map<string, SessionsServiceSession[]>();

  completed.forEach((session) => {
    const key = getBucketKey(session.created_at, range.bucket, timeZone);
    const group = sessionsByKey.get(key);
    if (group) group.push(session);
    else sessionsByKey.set(key, [session]);
  });

  return range.buckets.map((bucket) => ({
    start: bucket.start.toISOString(),
    ...sumTotals(sessionsByKey.get(bucket.key) ?? []),
  }));
};
